import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementConfigurationsStatuses } from '@api/manageNetworkElementConfigurations';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CONFIGURATION_STATUSES } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationStatusesReturned {
	statusesOptions: TSelectOption[];
	isLoadingStatusesOptions: boolean;
}

const useQueryNetworkElementConfigurationStatuses = (): IUseQueryNetworkElementConfigurationStatusesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CONFIGURATION_STATUSES],
		queryFn: getNetworkElementConfigurationsStatuses,
		select: nameTitleToOptionFormatted,
		...refetchOptions,
	});

	return {
		statusesOptions: data || [],
		isLoadingStatusesOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementConfigurationStatuses;
